"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dealerIdsQuery = exports.bosDealerQuery = void 0;
const types_1 = require("../../types");
exports.bosDealerQuery = `
  query dealer( $dealerId: String ) {
    dealer( dealerId: $dealerId ) {
      ...bosDealer
    }
  }
  ${types_1.bosDealerFragment}
`;
exports.dealerIdsQuery = `
  query findEmployeeByEmail($email: String!) {
    findEmployeeByEmail(email: $email) {
      dealers {
        dealerId
        name
      }
    }
  }
`;
//# sourceMappingURL=dealerQuery.js.map